export const ROUTING = 'ROUTING';
export const FETCH_FORM = 'FETCH_FORM';
export const FETCH_FORMS = 'FETCH_FORMS';
export const ADD_VALUE = 'ADD_VALUE';
export const SET_SECTION = 'SET_SECTION';
export const CLEAR_VALUES = 'CLEAR_VALUES';
export const SET_FORM_UID = 'SET_FORM_UID';
export const FETCH_VALUES = 'FETCH_VALUES';
export const OPEN_FORM = 'OPEN_FORM';
export const CHECKED_PANEL = 'CHECKED_PANEL';
export const AUTH_USER_SUCCESS = 'AUTH_USER_SUCCESS';
export const AUTH_USER_ERROR= 'AUTH_USER_ERROR';
export const ATTEMPT_TO_SEND = 'ATTEMPT_TO_SEND';
export const SET_STATUS_DEFAULT = 'SET_STATUS_DEFAULT';
export const CREATE_REQUEST_BEFORE = 'CREATE_REQUEST_BEFORE';
export const REQUEST_UNCHEK_UPDATE = 'REQUEST_UNCHEK_UPDATE';
export const MARK_VISITED = 'MARK_VISITED';
export const SET_ERROR = 'SET_ERROR';
export const MARK_ALL_VISITED = 'MARK_ALL_VISITED';
export const LOADING_START = 'LOADING_START';
export const LOADING_FINISH = 'LOADING_FINISH';
export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const FETCH_SETTINGS = 'FETCH_SETTINGS';
export const FETCH_SETTINGS_FINISHED = 'FETCH_SETTINGS_FINISHED';
export const SET_TAGS = 'SET_TAGS';
export const SET_CITIES = 'SET_CITIES';
export const SET_HISTORY = 'SET_HISTORY';
export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY';
export const REJECT_APPLICATION = "REJECT_APPLICATION";
